import { Container, Row, Col, Spinner, Nav, NavItem } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import Timeline from '../DayView/components/DayPlanTimeline';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';

const DayPlanIndexPlaceholder = ({ mealPlanNavigation, availableDays, date, loading2 }) => {
  const { t } = useTranslator();

  const {
    images: { favMealsIcon, shoppingListIcon },
  } = useAppContext();

  return (
    <Layout>
      <TitleBar showBackBtn={false}>
        {t('meals.navbarTitle')}
        <div className="title-bar-icons">
          <Link to="/meals/day-plan/module/shopping-list" className="ps-2">
            <img src={shoppingListIcon} alt="" />
          </Link>
          <Link to="/meals/day-plan/module/favourite-meals" className="ps-2">
            <img src={favMealsIcon} alt="" />
          </Link>
        </div>
      </TitleBar>

      <div className="page-template-meal-plan">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                {mealPlanNavigation && mealPlanNavigation.length > 0 && (
                  <div className="sub-navigation text-center">
                    <Container>
                      <Nav className="d-block">
                        {mealPlanNavigation.map((item) => (
                          <NavItem>
                            <NavLink to={item.path} replace={true} className="nav-link">
                              {t(item.translationKey)}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                    </Container>
                  </div>
                )}

                <Timeline availableDays={availableDays} date={date} loading={loading2} />
                <div className="full-height3">
                  <div className="loader-wrapper no-fixed">
                    <Spinner color="primary">{t('loading.message')}</Spinner>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default DayPlanIndexPlaceholder;
